import React from "react"

import "./ImageSection.scss"

const ImageSection = (props) => {
  return (
    <section className="room-page__image-section room-page__image-section--top">
      { props.acf.gallery.length > 0 && <img src={props.acf.gallery[0].localFile.childImageSharp.fluid.src} alt={props.acf.gallery[0].altText} /> }
      <div className="room-page__image-section__images">
        { props.acf.gallery.length > 1 &&
          <div className="room-page__image-section__images__image">
            <img src={props.acf.gallery[1].localFile.childImageSharp.fluid.src} alt={props.acf.gallery[1].altText} />
          </div>
        }
        { props.acf.gallery.length > 2 &&
          <div
            className="room-page__image-section__images__image"
            style={{ marginRight: 0 }}
          >
            <img src={props.acf.gallery[2].localFile.childImageSharp.fluid.src} alt={props.acf.gallery[2].altText} />
          </div>
        }
      </div>
    </section>
  )
}

export default ImageSection
